import Link from '@talkdesk/cobalt-react-link'
import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'
import { Text } from '@talkdesk/cobalt-react-typography'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import { useTranslation } from 'react-i18next'

const TalkdeskFooter = ({
  brandingSettings: { links, branding },
  showGoogleFooterLink,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Box as='footer' padding={4} width='100%' backgroundColor={theme.gray100}>
      <Flex alignX='space-between' alignY='center' gap={4}>
        <Text size='small' color={theme.gray600}>
          {t('footer.license', { copyright: branding.copyright })}
        </Text>
        <Flex as='nav' gap={4} wrap width='auto' alignX='end'>
          <Link target='_blank' href={links.support}>
            {t('footer.support')}
          </Link>
          <Link target='_blank' href={links['service-terms']}>
            {t('footer.termsOfService')}
          </Link>
          <Link target='_blank' href={links['privacy-policy']}>
            {t('footer.privacyPolicy')}
          </Link>
          {showGoogleFooterLink && (
            <Link target='_blank' href={links['google-api-services']}>
              {t('footer.googleApiServices')}
            </Link>
          )}
        </Flex>
      </Flex>
    </Box>
  )
}

export default TalkdeskFooter
